module.exports = __webpack_public_path__ + "static/invitee_bg.ba08b0ae.png";